var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10024_1604",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10024_1604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 11.333H8.66536V7.33301H7.33203V11.333ZM7.9987 5.99967C8.18759 5.99967 8.34592 5.93579 8.4737 5.80801C8.60148 5.68023 8.66536 5.5219 8.66536 5.33301C8.66536 5.14412 8.60148 4.98579 8.4737 4.85801C8.34592 4.73023 8.18759 4.66634 7.9987 4.66634C7.80981 4.66634 7.65148 4.73023 7.5237 4.85801C7.39592 4.98579 7.33203 5.14412 7.33203 5.33301C7.33203 5.5219 7.39592 5.68023 7.5237 5.80801C7.65148 5.93579 7.80981 5.99967 7.9987 5.99967ZM7.9987 14.6663C7.07648 14.6663 6.20981 14.4913 5.3987 14.1413C4.58759 13.7913 3.88203 13.3163 3.28203 12.7163C2.68203 12.1163 2.20703 11.4108 1.85703 10.5997C1.50703 9.78856 1.33203 8.9219 1.33203 7.99967C1.33203 7.07745 1.50703 6.21079 1.85703 5.39967C2.20703 4.58856 2.68203 3.88301 3.28203 3.28301C3.88203 2.68301 4.58759 2.20801 5.3987 1.85801C6.20981 1.50801 7.07648 1.33301 7.9987 1.33301C8.92092 1.33301 9.78759 1.50801 10.5987 1.85801C11.4098 2.20801 12.1154 2.68301 12.7154 3.28301C13.3154 3.88301 13.7904 4.58856 14.1404 5.39967C14.4904 6.21079 14.6654 7.07745 14.6654 7.99967C14.6654 8.9219 14.4904 9.78856 14.1404 10.5997C13.7904 11.4108 13.3154 12.1163 12.7154 12.7163C12.1154 13.3163 11.4098 13.7913 10.5987 14.1413C9.78759 14.4913 8.92092 14.6663 7.9987 14.6663ZM7.9987 13.333C9.48759 13.333 10.7487 12.8163 11.782 11.783C12.8154 10.7497 13.332 9.48856 13.332 7.99967C13.332 6.51079 12.8154 5.24967 11.782 4.21634C10.7487 3.18301 9.48759 2.66634 7.9987 2.66634C6.50981 2.66634 5.2487 3.18301 4.21536 4.21634C3.18203 5.24967 2.66536 6.51079 2.66536 7.99967C2.66536 9.48856 3.18203 10.7497 4.21536 11.783C5.2487 12.8163 6.50981 13.333 7.9987 13.333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.9e1a223bce925e2d153ee842254a3972.svg";
export { ForwardRef as ReactComponent };